import styled from 'styled-components';

import { AvatarImage } from '../../../components/avatar/styled-components';

export const TaskWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gullGray};
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.0801191);
  border-radius: 4px;
  font-size: 13px;
  padding: 14px;
  line-height: 1.69;
  
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  
  em {
    color: ${({ theme }) => theme.colors.fontLightBlack};
    font-style: normal;
  }
  
  p {
    margin-bottom: 8px;
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 1.37;
  color: ${({ theme }) => theme.colors.prussianBlue};
  margin-bottom: 8px;
`;

export const AssigneeWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  em {
    margin-left: 8px;
  }
`;

export const AvatarImageS = styled(AvatarImage)`
  border: none;
`;



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/task/styled-components.js